<template>
    <div id="search_page">
        <h3>Searching Page</h3>
        <b-container fluid>
            <b-row>
                <b-col cols="4">
                    <p>Output table</p>
                </b-col>
                <b-col cols="6">
                    <b-form-select v-model="output_select" :options="output_options">
                        <template v-slot:first>
                            <option :value=null disabled>-- Please select an output table --</option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="2">
                    <b-btn @click="click_search">Run Search</b-btn>
                </b-col>
            </b-row>
            <b-container fluid style="margin-top: 20px; margin-bottom: 20px">
                <b-row>
                    <b-col cols="1">Logical operator</b-col>
                    <b-col cols="2">Category</b-col>
                    <b-col cols="2">Field</b-col>
                    <b-col cols="2">Value</b-col>
                    <b-col cols="2">Operation</b-col>
                    <b-col cols="2">Negative</b-col>

                </b-row>
            </b-container>
            <SearchField v-for="(field, index) in fields"
            :key="index"
            :search="field"
            :index="index"
            :config="fields_config">

            </SearchField>
        </b-container>
    </div>
</template>

<script>
    import SearchField from "../components/SearchField";
    import axios from 'axios'
    export default {
        name: "SearchPage",
        components: {
            SearchField
        },
        data() {
            return {
                output_options: [
                    {value: 'protein', text: 'Protein table'},
                    {value: 'contig', text: 'Contigs table'},
                    {value: 'exp', text: 'Experiments table'}
                ],
                output_select: 'protein',
                fields_config: null
            }
        },
        computed: {
            fields() {
                return this.$store.state.container;
            }
        },
        methods: {
            click_search() {
                // this.$store.dispatch('add_data_search', [{name:'Hello'}]).then(() => {
                //     this.$router.push({path: `/${this.output_select}`})
                // });
                axios.post(`/get/search/${this.output_select}`,
                    this.$store.state.container)
                    .then(response => {
                        this.$store.dispatch('add_data_search', response.data)
                            .then(() => {
                                this.$router.push({path: `/${this.output_select}`})
                            })
                    })
            }
        },
        mounted() {
            axios.get('/get/config/search').then(response => {
                this.fields_config = response.data;
            })
        }
    }
</script>

<style scoped>

</style>